// extracted by mini-css-extract-plugin
export var content = "content-module--content--j7rTj";
export var contentHolder = "content-module--contentHolder--lhGtP";
export var holder = "content-module--holder--2lWSE";
export var menuHolder = "content-module--menuHolder--0DrHT";
export var positionLeft = "content-module--positionLeft--DDxLI";
export var positionRight = "content-module--positionRight--9-GK7";
export var stick = "content-module--stick--oW10E";
export var withStickyMenu = "content-module--withStickyMenu--HTKrl";